import React, { ReactNode } from 'react';
import { Toast, ToastMessage } from 'primereact/toast';
import LanguageUtil from './LanguageUtil';

class MessageUtil {
  public static messageModule: Toast | undefined;

  public static setMessageModule(module: Toast) {
    MessageUtil.messageModule = module;
  }

  static success = (message: Exclude<ToastMessage, 'severity'>) => {
    setTimeout(() => {
      MessageUtil.messageModule?.show({
        life: 1000,
        severity: 'success',
        ...message,
      });
    }, 0);
  };

  static error = (message: Exclude<ToastMessage, 'severity'>) => {
    setTimeout(() => {
      MessageUtil.messageModule?.show({
        life: 3000,
        severity: 'error',
        ...message,
      });
    }, 0);
  };

  static info = (message: Exclude<ToastMessage, 'severity'>) => {
    setTimeout(() => {
      MessageUtil.messageModule?.show({
        life: 1000,
        severity: 'info',
        ...message,
      });
    }, 0);
  };

  static warning = (message: Exclude<ToastMessage, 'severity'>) => {
    setTimeout(() => {
      MessageUtil.messageModule?.show({
        life: 1000,
        severity: 'warn',
        ...message,
      });
    });
  };

  public static checkPassword() {
    setTimeout(() => {
      MessageUtil.error({
        life: 3000,
        summary: <div>{LanguageUtil.get({ id: 'messages.user', defaultMessage: 'user' })}</div>,
        detail: <div>{LanguageUtil.get({ id: 'messages.warning.pCheck', defaultMessage: 'Please check your password!' })}</div>,
      });
    }, 0);
  }

  public static checkEmail() {
    setTimeout(() => {
      MessageUtil.error({
        life: 3000,
        summary: <div>{LanguageUtil.get({ id: 'messages.user', defaultMessage: 'user' })}</div>,
        detail: <div>{LanguageUtil.get({ id: 'messages.warning.eCheck', defaultMessage: 'Please check your email!' })}</div>,
      });
    }, 0);
  }

  public static alreadyExist(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.error({
        life: 3000,
        summary,
        detail: <div data-testid={`already_exist`}>{LanguageUtil.get({ id: 'messages.warning.already', defaultMessage: 'already exist.' })}</div>,
      });
    }, 0);
  }

  public static showCreated(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.success({
        life: 1000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.created', defaultMessage: 'Created' })}</div>,
      });
    }, 0);
  }

  public static showUpdated(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.success({
        life: 1000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.updated', defaultMessage: 'Updated' })}</div>,
      });
    }, 0);
  }

  public static showDeleted(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.info({
        life: 1000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.deleted', defaultMessage: 'Deleted' })}</div>,
      });
    }, 0);
  }

  public static showAdded(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.success({
        life: 1000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.added', defaultMessage: 'Added' })}</div>,
      });
    }, 0);
  }

  public static showError(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.error({
        life: 3000,
        summary: summary || 'An error',
        detail: <div>{LanguageUtil.get({ id: 'messages.error.error', defaultMessage: 'Error.' })}</div>,
      });
    }, 0);
  }

  public static deleteMessage(summary: string) {
    setTimeout(() => {
      MessageUtil.success({
        life: 1000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.deleted', defaultMessage: 'Deleted.' })}</div>,
      });
    }, 0);
  }

  public static sameMessage(summary: string | ReactNode) {
    setTimeout(() => {
      MessageUtil.error({
        life: 3000,
        summary,
        detail: <div>{LanguageUtil.get({ id: 'messages.warning.same', defaultMessage: 'Make some changes to save' })}</div>,
      });
    }, 0);
  }
}

export default MessageUtil;
